import member from '../../src/views/data/member'
import financial from '../../src/views/data/financial'
import project from '../../src/views/data/project'
import customer from '../../src/views/data/customer'
import tracking from '../../src/views/data/tracking'
import networkDisk from '../../src/views/data/networkDisk'

export default {
  member:member,
  financial:financial,
  project:project,
  customer:customer,
  tracking:tracking,
  networkDisk:networkDisk,
}